<template>
    <a class="p-button p-button-sm border-amber-400 bg-amber-400 cursor-auto" @click="stopHandler($event)" v-if="disabled">
        <IconEdit class="mr-2" />
        <slot></slot>
    </a>
    <Link :href="url" class="p-button p-button-sm border-amber-500 bg-amber-500 hover:bg-amber-600" v-else>
        <IconEdit class="mr-2" />
        <slot></slot>
    </Link>
</template>
<script>
    import { defineComponent } from 'vue'
    import { Link } from '@inertiajs/inertia-vue3';
    import IconEdit from '@/Icons/Edit'

    export default defineComponent({
        props: {
            url: {
                type: String,
            },
            disabled: {
                type: Boolean,
                default: false
            },
        },
        components: {
            Link,
            IconEdit,
        },
        methods: {
            stopHandler: function(event){event.preventDefault()}
        }
    })
</script>